import {FC, SVGProps, useId} from 'react';

export const NotificationsIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
	const maskId = `notifications-bell-${useId().replace(/:/g, '')}`;

	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
			<mask id={maskId} fill="white">
				<path d="M12 2C15.866 2 19 5.13401 19 9V18H5V9C5 5.13401 8.13401 2 12 2Z" />
			</mask>
			<path
				d="M12 2C15.866 2 19 5.13401 19 9V18H5V9C5 5.13401 8.13401 2 12 2Z"
				strokeWidth="3.2"
				stroke="currentColor"
				mask={`url(#${maskId})`}
			/>
			<rect x="3" y="16.3999" width="18" height="1.6" fill="currentColor" />
			<rect x="9" y="19.3999" width="6" height="1.6" fill="currentColor" />
		</svg>
	);
};
